import React from "react";
import { Link } from "react-router-dom";
import PublicPage from "./PublicPage";
import LegalTabs from "./LegalTabs";

export default function Terms() {
    return (
        <PublicPage kicker="&gt; legal.terms" title="Terms of Service" updated="July 2026" testid="page-terms" tabs={<LegalTabs />}>
            <p>
                These terms govern your use of Vyaahar. By creating an account or using the service, you agree to
                them. If you don't agree, don't use the service.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>The service</h2>
            <p>
                Vyaahar is a cloud accounting platform provided by Vyastics Technologies Private Limited. Features
                include books, invoicing, GST filing, bank reconciliation, reporting, and an AI Copilot.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Your account</h2>
            <ul>
                <li>You are responsible for keeping your credentials secure.</li>
                <li>You are responsible for the accuracy of data you upload — including GSTINs, HSN codes, and financial figures.</li>
                <li>You must not use the service to violate any law or infringe on anyone's rights.</li>
            </ul>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Fees</h2>
            <p>
                Paid plans are billed monthly or annually in advance. If you cancel, you retain access until the
                end of the current billing period. Fees are non-refundable except where required by law.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Your data</h2>
            <p>
                Your data stays yours. We store and process it only to provide the service. See our
                {" "}<Link to="/legal/privacy" style={{ color: "var(--vy-gold)" }}>Privacy Policy</Link> for details.
                You can export your data at any time.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Availability</h2>
            <p>
                We work hard to keep Vyaahar available. Planned maintenance is communicated in advance. Unplanned
                outages are rare but possible; we do not guarantee uninterrupted service.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Limitation of liability</h2>
            <p>
                To the fullest extent permitted by law, our aggregate liability for any claim is limited to the fees
                you paid us in the twelve months preceding the claim. Vyaahar is a tool — you remain responsible
                for the accuracy of your books and filings.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Termination</h2>
            <p>
                You can cancel at any time from Settings. We can suspend or terminate accounts that violate these
                terms or applicable law.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Modifications to these terms</h2>
            <p>
                We may update these terms from time to time. Material changes will be announced on this page with a
                new "last updated" date, and where required by law, we will notify you directly.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Governing law</h2>
            <p>These terms are governed by the laws of India. Disputes fall under the exclusive jurisdiction of courts at Chennai, Tamil Nadu.</p>
            <p style={{ marginTop: 20 }}>Questions? Email <a href="mailto:hello@scitus.ai" style={{ color: "var(--vy-gold)" }}>hello@scitus.ai</a>.</p>
        </PublicPage>
    );
}
